var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%", height: "100vh" } },
    [
      _c(
        "fullscreen",
        {
          staticStyle: {
            height: "100%",
            background: "#f7f8fa",
            "overflow-y": "auto",
          },
          attrs: { fullscreen: _vm.fullscreen },
          on: {
            "update:fullscreen": function ($event) {
              _vm.fullscreen = $event
            },
            change: _vm.fullscreenChange,
          },
        },
        [
          _vm.fullscreen
            ? _c("Preview", {
                attrs: {
                  "component-data": _vm.mainCanvasComponentData,
                  "canvas-style-data": _vm.canvasStyleData,
                  "panel-info": _vm.panelInfo,
                  "in-screen": !_vm.fullscreen,
                },
              })
            : _vm._e(),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }